<template>
  <section class="rooms">
    <ul class="prodRooms list-unstyled mt-3" v-if="prodRooms">
      <rooms-item
        v-for="room in prodRooms"
        mode="prod"
        :room="room"
        :key="room.id">
      </rooms-item>
    </ul>
    <ul class="testRooms list-unstyled" v-if="testRooms">
      <rooms-item
        v-for="room in testRooms"
        mode="test"
        :room="room"
        :key="room.id">
      </rooms-item>
    </ul>
  </section>
</template>

<script>
import {
  mapGetters
  // mapState
} from 'vuex'
import RoomsItem from './RoomsItem'
// import l from '@/vendor/logger'

export default {
  name: 'Rooms',

  computed: {
    ...mapGetters('rooms', [
      'prodRooms',
      'testRooms'
    ])
  },

  components: {
    RoomsItem
  }
}
</script>

<style scoped>
.rooms {
}
</style>
